/**
 * Location Utilities
 *
 * Utility functions for working with location data (airports, cities)
 */

/**
 * Generate a unique, sanitized ID for a location
 *
 * @param iata - IATA airport code (e.g., "DEL", "BOM")
 * @param cityName - City name (e.g., "New Delhi", "São Paulo")
 * @param countryCode - ISO country code (e.g., "IN", "US")
 * @returns Sanitized unique identifier
 *
 * @example
 * generateLocationId("DEL", "New Delhi", "IN")
 * // Returns: "DEL_new_delhi_in"
 *
 * generateLocationId("GRU", "São Paulo", "BR")
 * // Returns: "GRU_sao_paulo_br"
 */
export function generateLocationId(iata: string, cityName: string, countryCode: string): string {
  const sanitizedCity = cityName
    .toLowerCase()
    .normalize('NFD') // Normalize to decomposed form
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics (accents)
    .replace(/[^a-z0-9]/g, '_') // Replace non-alphanumeric with underscore
    .replace(/_+/g, '_') // Collapse multiple underscores
    .replace(/^_|_$/g, ''); // Remove leading/trailing underscores

  return `${iata}_${sanitizedCity}_${countryCode.toLowerCase()}`;
}
